// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@ces/XDL/PreStyle/typography";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { css } from "styled-components";

interface XProductPartNumbersStyles {
    label: TypographyPresentationProps;
    value: TypographyPresentationProps;
}

const mediumTextStyles: TypographyPresentationProps = {
    size: 12,
    weight: fontConfig.weight.regular,
    color: "text",
    lineHeight: "15px",
};

const xProductPartNumbersStyles: XProductPartNumbersStyles = {
    label: {
        ...mediumTextStyles,
        weight: fontConfig.weight.bold,
        transform: "uppercase",
        css: css`
            letter-spacing: 0;
            margin-right: 4px;
            text-wrap: nowrap;
            &:after {
                content: ":";
            }
        `,
    },
    value: {
        ...mediumTextStyles,
        ellipsis: true,
        color: "common.ui5",
        css: css`
            letter-spacing: 0;
            ${wrapInContainerStyles}
        `,
    },
};

export default xProductPartNumbersStyles;
